import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d55da95")

_pushScopeId("data-v-4d55da95")
const _hoisted_1 = { class: "general" }
const _hoisted_2 = {
  class: "file-window",
  id: "fullscreenView"
}
const _hoisted_3 = { class: "div-title" }
const _hoisted_4 = {
  key: 0,
  class: "file-name"
}
const _hoisted_5 = {
  class: "mr-1",
  style: {"float":"right"}
}
const _hoisted_6 = { class: "iframe" }
const _hoisted_7 = { class: "right-side" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "div-title" }, [
  /*#__PURE__*/_createVNode("ul", { class: "tabs" }, [
    /*#__PURE__*/_createVNode("li", { class: "active" }, "General Files")
  ])
], -1)
const _hoisted_9 = { class: "meeting-note" }
const _hoisted_10 = { class: "file-list" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h4", null, "General files", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = { style: {"max-height":"400px","overflow":"auto"} }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fal fa-file-pdf" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "del-btn" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_18 = { class: "ls-slate" }
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_HelpScreen = _resolveComponent("HelpScreen")
  const _component_FullScreenFileViewer = _resolveComponent("FullScreenFileViewer")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.currentFile && _ctx.currentCommittee)
          ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.currentCommittee.name) + " | " + _toDisplayString(_ctx.currentFile.name), 1))
          : _createCommentVNode("", true),
        _createVNode("span", _hoisted_5, [
          _createVNode("i", {
            class: "fal fa-arrows-alt",
            "aria-hidden": "true",
            title: "Enter Fullscreen",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.openFullscreen(_ctx.currentFile))),
            style: {"transform":"rotate(45deg)","font-size":"1.5em","cursor":"pointer"}
          })
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("iframe", {
          id: "refDocViewer",
          ref: "refDocViewer",
          class: "vue-doc-viewer",
          src: _ctx.fileSource,
          title: "iframe"
        }, "\n      ", 8, ["src"])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createVNode("ul", _hoisted_13, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.generalFiles, (f, index) => {
              return (_openBlock(), _createBlock("li", {
                class: ["file-name", _ctx.fileId == f.id ? 'current' : ''],
                onClick: $event => (_ctx.openFile(f))
              }, [
                _createVNode("div", {
                  title: f.name
                }, [
                  _createVNode("p", null, [
                    _hoisted_14,
                    _createTextVNode(_toDisplayString(f.name), 1)
                  ])
                ], 8, ["title"]),
                _hoisted_15
              ], 10, ["onClick"]))
            }), 256))
          ]),
          _hoisted_16,
          _hoisted_17
        ])
      ])
    ]),
    (_ctx.showHelpScreen)
      ? (_openBlock(), _createBlock(_component_HelpScreen, {
          key: 0,
          onClose: _cache[2] || (_cache[2] = $event => (_ctx.showHelpScreen = false))
        }, {
          header: _withId(() => [
            _createVNode("h3", _hoisted_18, _toDisplayString(_ctx.pageHeader), 1)
          ]),
          body: _withId(() => [
            _createVNode("p", null, _toDisplayString(_ctx.pageDescription), 1),
            _hoisted_19,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageSection, (s, index) => {
              return (_openBlock(), _createBlock("div", null, [
                _createVNode("h4", null, _toDisplayString(s.sectionHeading), 1),
                _createVNode("p", null, _toDisplayString(s.sectionContent), 1),
                _hoisted_20
              ]))
            }), 256))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showFullScreenFileViewer)
      ? (_openBlock(), _createBlock(_component_FullScreenFileViewer, {
          key: 1,
          onClose: _cache[3] || (_cache[3] = $event => (_ctx.showFullScreenFileViewer = false))
        }, {
          header: _withId(() => [
            _createVNode("h4", null, _toDisplayString(_ctx.currentFile.name), 1)
          ]),
          body: _withId(() => [
            _createVNode("iframe", {
              id: "refDocViewer",
              ref: "refDocViewer",
              style: {"width":"99%","height":"100vh"},
              class: "vue-doc-viewer",
              src: _ctx.fileSource,
              title: "iframe"
            }, "\n      ", 8, ["src"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
})